module.exports = __webpack_public_path__ + "b0178b141f256a3c853b8db4532bab6e.jpg";